import React, {useEffect, useState} from 'react';
import {agregarNota} from "../../redux/reducers/prestamosReducer"
import {useNavigate} from "react-router-dom";
import Strings from "../../assets/strings";
import {Button, Dialog, DialogActions, DialogContent, Grid, TextField} from '@mui/material';
import {LoadingProgress, TopBarDialog} from "../../components";
import {useAppDispatch, useAppSelector} from "../../redux/hooks";
import {INota, IPrestamoDetalle} from "../../redux/types/IPrestamo";


const initialState:INota = {
  id:undefined,
  prestamoId:undefined,
  nota: "",
  fechaCreacion: "",
  fechaRecordatorio: ""
}
export default function NotasPrestamo(){
  let {id: prestamoId} = useAppSelector(state => state.prestamos.byId || {} as IPrestamoDetalle);
  let {status} = useAppSelector(state => state.prestamos);
  let dispatch = useAppDispatch();

  let navigate = useNavigate();
  const [state, setState] = useState<INota>(initialState);

  const handleChange = (e:React.ChangeEvent<HTMLTextAreaElement>) => {
    const {value,name} = e.target;
    setState({...state,[name]:value});
  };
  const submit = (e:React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    dispatch(agregarNota({...state,prestamoId}));
  };
  useEffect(()=>{setState(initialState)},[setState])

  return (
      <Dialog open={true} fullWidth maxWidth={"xs"} disableEscapeKeyDown>
        <TopBarDialog title={Strings.agregar +" "+Strings.nota} onClose={()=>navigate(-1)} nofullScreen/>
        <DialogContent>
          {status === "loading" && <LoadingProgress vh={false} />}
          <form onSubmit={submit} id={"formNota"}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <TextField
                    required
                    multiline
                    label={Strings.nota}
                    placeholder={Strings.agregar+" "+Strings.notas}
                    value={state.nota}
                    name="nota"
                    onChange={handleChange}
                    fullWidth
                    rows={3}
                    inputProps={{
                      maxLength:256
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                    label={Strings.fechaRecordatorio}
                    type="date"
                    name="fechaRecordatorio"
                    value={state.fechaRecordatorio}
                    onChange={handleChange}
                    fullWidth
                    InputLabelProps={{
                      shrink: true,
                    }}
                />
              </Grid>
            </Grid>
          </form>
        </DialogContent>
        <DialogActions>

            <Button type={"button"} color="warning" variant={"text"} onClick={()=>navigate(-1)}>
                {Strings.cancelar}
            </Button>
            <Button type="submit" form={"formNota"} color="primary"  disabled={status === "loading"} variant={"outlined"}
            >
                {!!state.id ? Strings.actualizar : Strings.guardar}
            </Button>


        </DialogActions>
      </Dialog>
  );
}


